import React, { useState } from "react";
import { Box, Typography, Paper, MobileStepper, IconButton } from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PolicyIcon from "@mui/icons-material/Policy";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"; 
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const CircularCarousel = ({ items = [], rotateSpeed = 40, cardWidth = "23%", pauseOnHover = false, onItemClick, }) => {

  // Slider en mobile XS
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = items.length;
  const handleNext = () => { setActiveStep((prevStep) => (prevStep + 1) % maxSteps);}; 
  const handleBack = () => { setActiveStep((prevStep) => prevStep === 0 ? maxSteps - 1 : prevStep - 1 ); }; 
  const contenidoSlider = items[activeStep];

  // Circular Carousel MD > en adelante
  if (!items.length) { return null;}
  const count = items.length;

  return (
    <>
      {/* Slider en mobile XS */}
      <Box sx={{ 
        display: { xs: "block", md: "none", },
        width: "100%",
        px: 2,
        py: 3,
      }}> 
        <Paper elevation={3} sx={{
          width: "100%",
          overflow: "hidden",
          borderRadius: 3,
          backgroundColor: "primary.light", 
        }}> 
          <Typography variant="h6" sx={{
            color:"white",
            placeSelf: "center",
            width:"70%",
            backgroundColor: "primary.dark",
            borderRadius: "16px",
            textAlign: "center",
            fontSize:{xs:"32px"},
            mt:"20px",
            padding: "8px 14px",
            lineHeight: 1.2,
          }}>
            CONOCE NUESTRA FILOSOFÍA
          </Typography>

          {/* Contenido */} 
          <Box sx={{ 
            px: 3,
            py: 3, 
            minHeight: 200, 
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            animation: "fadeIn 0.4s ease", 
            "@keyframes fadeIn": { from: 
              { opacity: 0,
                transform: "translateX(15px)",
              }, 
              to: 
              { opacity: 1, 
                transform: "translateX(0)",
              }, 
            }, 
          }}>
          <Typography variant="h5" component="h2" align="center" sx={{ fontWeight: 700, mb: 2, color:"white" }} >
            {contenidoSlider.titulo} 
          </Typography> 
          <Typography variant="body1" align="center" sx={{ lineHeight: 1.7, color: "text.secondary", color:"white"}} >
            {contenidoSlider.description} </Typography> 
          </Box> 
          {/* Controles */} 
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between", 
            px: 1, 
            pb: 1, 
          }}> 
            <IconButton onClick={handleBack} aria-label="Anterior" sx={{
              transition: "all 0.2s ease", 
              color:"white",
              "&:hover": { 
                transform: "scale(1.1)", 
                backgroundColor: "action.hover",
              }, 
            }}> 
              <KeyboardArrowLeftIcon /> 
            </IconButton> 
            <MobileStepper variant="dots" steps={maxSteps} position="static" activeStep={activeStep} sx={{
              flex: 1, 
              justifyContent: "center", 
              backgroundColor: "transparent", 
            }} 
              nextButton={null}
              backButton={null} 
            /> 
            <IconButton onClick={handleNext} aria-label="Siguiente" sx={{
              transition: "all 0.2s ease",
              color:"white",
              "&:hover": { 
                transform: "scale(1.1)",
                backgroundColor: "action.hover",
              }, 
            }}>
              <KeyboardArrowRightIcon /> 
            </IconButton> 
          </Box> 
        </Paper> 
      </Box>

      {/* Circular Carousel MD > en adelante */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",

          "@keyframes rotateCW": {
            from: {
              transform: "translate3d(0px, -50%, -1px) rotate(-45deg)",
            },
            to: {
              transform: "translate3d(0px, -50%, 0px) rotate(-315deg)",
            },
          },

          "@keyframes rotateCCW": {
            from: {
              transform: "rotate(45deg)",
            },
            to: {
              transform: "rotate(315deg)",
            },
          },

          "@keyframes pulseGlow": {
            from: {
              backgroundSize: "60%",
            },
            to: {
              backgroundSize: "100%",
            },
          },
        }}
      >

        {/* CONTENEDOR PRINCIPAL */}
        <Box sx={{
          display: { xs: "none", md: "block", },
          backgroundColor:"primary.deep",
          width: "100%",
        }}>
          <Box
            sx={{
            maxWidth:{sm:"768px", md:"925px", lg:"980px"},
            position: "relative",
            aspectRatio: "1 / 1",
            margin: "auto",
          }}>

            {/* CÍRCULOS DE FONDO */}
            <Box
              sx={{
                position: "absolute",
                width: "66%",
                aspectRatio: "1 / 1",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                background: "#F5F4FE",
                opacity: 0.25,
                boxShadow: "0px 18px 36px -18px rgba(12, 5, 46, 0.3), 0px 30px 60px -12px rgba(12, 5, 46, 0.25)",
                borderRadius: "50%",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                width: "40%",
                aspectRatio: "1 / 1",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                background: "#F5F4FE",
                opacity: 0.5,
                boxShadow: "0px 18px 36px -18px rgba(12, 5, 46, 0.3), 0px 30px 60px -12px rgba(12, 5, 46, 0.25)",
                borderRadius: "50%",
              }}
            />

            {/* CÍRCULO CENTRAL */}
            <Box
              sx={{
                position: "absolute",
                width: {xs: "150px", sm: "190px", md: "230px"},
                aspectRatio: "1 / 1",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                background: "#FFFFFF",
                boxShadow: "0px 18px 36px -18px rgba(12, 5, 46, 0.3), 0px 30px 60px -12px rgba(12, 5, 46, 0.25)",
                borderRadius: "50%",
                zIndex: 2,
              }}
            />

            {/* LADO DERECHO / TARJETAS */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                WebkitMaskImage: "linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0) 50%, rgba(0,0,0,1) 50%, rgba(0,0,0,1))",
                maskImage: "linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0) 50%, rgba(0,0,0,1) 50%, rgba(0,0,0,1))",
                zIndex: 3,
              }}
            >
              <Box
                component="ul"
                sx={{
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                  position: "relative",
                  width: "100%",
                  height: "100%",
                }}
              >
                {items.map((item, index) => {
                  const delay =
                    (rotateSpeed / count) * -index;

                  return (
                    <Box
                      component="li"
                      key={item.id ?? index}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        width: "100%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",

                        animation: `
                          rotateCW
                          ${rotateSpeed}s
                          cubic-bezier(0, 0.37, 1, 0.63)
                          infinite
                        `,

                        animationDelay: `${delay}s`,
                        
                        // Pausar el carrusel cuando el usuario coloca el cursor encima.
                        ...(pauseOnHover && {
                          "&:hover": {
                            animationPlayState: "paused",
                          },

                          "&:hover .circular-carousel-card": {
                            animationPlayState: "paused",
                          },
                        }),
                      }}
                    >
                      {/* Tarjeta visible */}
                      <Box
                        className="circular-carousel-card"
                        onClick={() => {
                          if (onItemClick) {
                            onItemClick(item, index);
                          }
                        }}
                        sx={{
                          pointerEvents: "auto",
                          width: cardWidth,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "20px 10px",
                          gap: "15px",
                          backgroundColor: "#FFFFFF",
                          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1), 0px 16px 32px rgba(0, 0, 0, 0.1)",
                          borderRadius: "12px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: "14px",
                          textAlign: "center",
                          lineHeight: "20px",
                          color: "#535062",
                          cursor: onItemClick ? "pointer" : "default",

                          animation: `
                            rotateCCW
                            ${rotateSpeed}s
                            cubic-bezier(0, 0.37, 1, 0.63)
                            infinite
                          `,
                          animationDelay: `${delay}s`,
                          transition: "box-shadow 0.3s ease, transform 0.3s ease",
                          "&:hover": {boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15), 0px 20px 40px rgba(0, 0, 0, 0.12)"},
                        }}
                      >

                        {/* CONTENIDO DE LA TARJETA */}
                        <Box
                          sx={{
                            textDecoration: "none",
                            color: "inherit",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            //gap: "15px",
                          }}
                        >

                          {/* TITULO */}
                          {item.titulo && (
                            <Typography
                              sx={{
                                fontSize: {xs: "14px", sm: "16px", md: "18px"},
                                lineHeight: "150%",
                                fontWeight: "bold",
                                color: "primary.dark",
                                display: "block",
                                paddingBottom: "5px",
                              }}
                            >
                              {item.titulo}
                            </Typography>
                          )}

                          {/* DESCRIPCIÓN OPCIONAL */}
                          {item.description && (
                            <Typography
                              sx={{
                                fontSize: "13px",
                                lineHeight: 1.4,
                                color: "#535062",
                              }}
                            >
                              {item.description}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            {/* LADO IZQUIERDO */}
            <Box sx={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              width: "50%",
              backgroundColor: "primary.deep",
              alignContent: "center",
              zIndex: 5,

              "&::after": {
                content: '""',
                position: "absolute",
                width: "1px",
                height: "100%",
                right: 0,
                display: "block",
                backgroundImage: "linear-gradient(180deg, rgba(60, 26, 229, 0) 0%, primary.deep 50%, rgba(60, 26, 229, 0) 100%)",
              },
            }}>
              <Typography variant="h6" sx={{
                color:"white",
                fontWeight:"bold",
                fontSize:{md:"60px", lg:"70px"},
                padding: "6px 35px 6px 20px",
                textAlign: "center",
                lineHeight: 1.1,
              }}>
                CONOCE NUESTRA FILOSOFÍA
                <br/>
                <LocalHospitalIcon sx={{ fontSize: 80, color: "#8FE7FF", display:"none" }} />
                {/* <AccountBalanceIcon sx={{ fontSize: 40, color: "#7f5539" }} />
                <PolicyIcon sx={{ fontSize: 40, color: "#2e7d32" }} /> */}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CircularCarousel;
